import config from "config/config";
import type { HowItWorksSectionProps } from "./HowItWorksABCTest.d";

export const configHowItWorksABCTest: HowItWorksSectionProps = {
  topHeading: "HOW IT WORKS",
  heading: "Getting compensation was never easier",
  cards: [
    {
      heading: "Submit your claim",
      content: "Provide details about yourself and your flight, plus supporting documents.",
      imageSrc: `${config.staticUrl}/i/homepage/spot-illustrations-256_256-submit-2-minutes.png`,
    },
    {
      heading: "We take care of it",
      content:
        "We file your claim and handle all airline correspondence for you. We'll even bring in a lawyer if needed.",
      imageSrc: `${config.staticUrl}/i/homepage/spot-illustrations-256_256-we-take-care.png`,
    },
    {
      heading: "You get paid",
      content: "We get your bank details and transfer your compensation, minus our success fee.",
      imageSrc: `${config.staticUrl}/i/homepage/spot-illustrations-256_256-no-win-no-fee.png`,
    },
  ],
  ctaText: "Check compensation",
};
